var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cover"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "mask-wrapper"
  }, [_c('div', {
    staticClass: "mask-container"
  }, [_c('img', {
    directives: [{
      name: "scroll-animate",
      rawName: "v-scroll-animate"
    }],
    attrs: {
      "src": _vm.field.value.image,
      "alt": ""
    }
  })])]), _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('div', {
    directives: [{
      name: "scroll-animate",
      rawName: "v-scroll-animate"
    }],
    staticClass: "logo-box"
  }, [_vm._m(0)])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "logo-container"
  }, [_c('div', {
    staticClass: "asset-container"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/logo/seu-logo-name.svg"),
      "alt": ""
    }
  })])]);

}]

export { render, staticRenderFns }